const recaptchaServiceMixin = {
    data: function () {
        return {
            RECAPTCHA_BASE: '/Api/Recaptcha/'
        }
    },
    methods: {
        validateRecaptchaRetrieve: function () {
            return this.post(this.RECAPTCHA_BASE, 'ValidateRetrieve', null, true);
        }
    }
}